/**
 * The ivyx mark, carried inline by the profile.
 *
 * Hosts serve the renderer from different roots — the electron host ships
 * `logo.svg` next to `index.html`, the browser host ships no such file — so a
 * relative URL resolves in one and 404s in the other. A data URI travels with
 * the profile and renders identically in both, including in `file://` and
 * packaged contexts.
 */
const MARK_SVG = [
  `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 99.21 99.21'>`,
  `<circle cx='49.61' cy='49.61' r='49.61' fill='#0870fd'/>`,
  `<g fill='none' stroke='#fff' stroke-width='5' stroke-miterlimit='10' stroke-linecap='round'>`,
  `<path d='M86.3,53.2c.13-1.24.19-2.5.19-3.77,0-20.37-16.51-36.88-36.88-36.88-8.01,0-15.42,2.55-21.47,6.89l.14-.08c-2.19,1.49-2.76,4.48-1.27,6.67s4.48,2.76,6.67,1.27c0,0,14.81-10.43,30.03-.12l.14.08-.14-.08c2.19,1.49,2.76,4.48,1.27,6.67-1.49,2.19-4.48,2.76-6.67,1.27,0,0-10.17-7.22-19.87,1.26'/>`,
  `<circle cx='34.55' cy='40.56' r='4.96' fill='#fff'/>`,
  `<circle cx='13.8' cy='40.56' r='4.96' fill='#fff'/>`,
  `<circle cx='66.75' cy='58.16' r='4.96' opacity='.99'/>`,
  `<circle cx='85.41' cy='58.16' r='4.96' opacity='.99'/>`,
  `<path d='M13.99,46.01c-.13,1.24-.19,2.5-.19,3.77,0,20.37,16.51,36.88,36.88,36.88,8.01,0,15.42-2.55,21.47-6.89l-.14.08c2.19-1.49,2.76-4.48,1.27-6.67-1.49-2.19-4.48-2.76-6.67-1.27,0,0-14.81,10.43-30.03.12l-.14-.08.14.08c-2.19-1.49-2.76-4.48-1.27-6.67s4.48-2.76,6.67-1.27c0,0,10.17,7.22,19.87-1.26'/>`,
  `</g></svg>`
].join('');

/** `identity.branding.logo` value for the ivyx profiles. */
export const IVYX_MARK = `data:image/svg+xml,${encodeURIComponent(MARK_SVG)}`;
